/** @rpg/collision: collision and physics on Rapier (spike 002, phase A1; card engine/docs/composer/cards/collision.md). */
import RAPIER from "@dimforge/rapier3d-compat";
import type { Rapier } from "./world";

export const COLLISION_VERSION = "0.4.0" as const;

export {
  CollisionWorld,
  createCollisionWorld,
  COLLISION_SNAPSHOT_FORMAT,
  type Rapier,
  type Vec3,
  type Quat,
  type BodyId,
  type BodyKind,
  type PrimitiveShape,
  type ShapeSpec,
  type ColliderSpec,
  type BodySpec,
  type CollisionWorldOptions,
  type QueryOptions,
  type Hit,
  type BodyState,
  type CollisionSnapshot,
  type CollisionFaults,
  type CharacterSpec,
  type CharacterContact,
  type CharacterMove,
  type Impact,
} from "./world";
export {
  relativeTurn,
  sphericalAngles,
  revoluteAngle,
  limitExcess,
  outside,
  type JointId,
  type JointSpec,
  type SphericalJointSpec,
  type RevoluteJointSpec,
  type AngleRange,
  type JointAngles,
} from "./joints";
export { WaterVolumes, waterChannel, waterPolygon, waterShapeDistance, waterShapeSurface, waterLevel, checkWaterShape, type WaterVolume, type WaterAt, type WaterShape, type ChannelPoint, type WaterQuery } from "./water";
export { createLayers, MAX_LAYERS, type LayerTable, type Layers, type InteractionGroups } from "./layers";
export { toBase64, fromBase64 } from "./base64";

let ready: Promise<Rapier> | null = null;

/** Load and initialise Rapier's WASM once; later calls share the same promise. */
export function initCollision(): Promise<Rapier> {
  ready ??= RAPIER.init().then(() => RAPIER);
  return ready;
}
